import FaqAccordion from './faq-accordion';

export default FaqAccordion;
